import getDisplayName from './getDisplayName';

export default function generateUpdateMessage({
  message,
  statusesList,
  username,
  t,
  usersList,
}) {
  const messageObject = JSON.parse(message);

  const getStatusName = (statusVal) => {
    let status = statusesList.find((s) => Number(s.statusId) === Number(statusVal));

    if (!status) {
      status = statusesList.find(
        (s) => s.name?.toUpperCase() === String(statusVal).toUpperCase()
      );
    }

    return status ? t(`status.${status.name}`) : statusVal || '';
  };
  const updatesList = Object.keys(messageObject).map((key) => {
    const entry = messageObject[key];
    let prevVal = entry.previousValue;
    let newVal = entry.newValue;
    switch (key) {
      case 'Status':
        prevVal = getStatusName(prevVal);
        newVal = getStatusName(newVal);
        if (!prevVal || !newVal) return undefined;
        break;

      case 'Priority':
        prevVal = t(`priority.${prevVal}`);
        newVal = t(`priority.${newVal}`);
        break;

      case 'Description':
        return t('pages.ticketDetails.ticketUpdateDescriptionLog', {
          user: username || '',
        });

      case 'Creation':
        return t('pages.ticketDetails.ticketCreatedLog', {
          user: username || '',
        });

      case 'Tagged':
        return t('pages.ticketDetails.userTaggedLog', {
          username,
          username2: entry.userName,
          permission: entry.write
            ? t('pages.ticketDetails.readAndModify')
            : t('pages.ticketDetails.onlyRead'),
        });

      case 'Untagged':
        return t('pages.ticketDetails.userUntaggedLog', {
          username,
          username2: entry.userName,
        });

      case 'updatePerm':
        return t('pages.ticketDetails.updatePermLog', {
          username,
          username2: entry.userName,
          permission: entry.write
            ? t('pages.ticketDetails.readAndModify')
            : t('pages.ticketDetails.onlyRead'),
        });

      case 'AssignedTo': {
        const prevUser =
          prevVal === '-1' || prevVal === -1
            ? 'None'
            : getDisplayName(
                usersList.find((user) => user.id === parseInt(prevVal, 10))
              ) || prevVal;

        const newUser =
          newVal === '-1' || newVal === -1
            ? 'None'
            : getDisplayName(
                usersList.find((user) => user.id === parseInt(newVal, 10))
              ) || newVal;

        return t('pages.ticketDetails.ticketReassignedLog', {
          user: username || '',
          previousAgent: prevUser,
          newAgent: newUser,
        });
      }

      case 'Tags':
        return t('pages.ticketDetails.ticketTagsUpdatedLog', { user: username || '' });

      default:
        break;
    }

    return t('pages.ticketDetails.ticketUpdateLog', {
      user: username || '',
      attribute: t(`attributes.${key.toLowerCase()}`),
      prevValue: prevVal,
      newValue: newVal,
    });
  });

  return updatesList.filter(Boolean);
}
